import type { Route } from '@angular/router';
import {
  hasStringPathParamCanActivateGuard,
  sequentialDeactivateGuards,
} from '@pct-ng/core/router';
import { showToasterDeactivateGuard } from '@pct-ng/form';
import { dirtyCheckCanDeactivateGuard } from '@pct-ng/feature-dirty-check';

export const adminUserRoutes: Route[] = [
  {
    path: '',
    loadComponent: () =>
      import('./list/admin-user-list.component').then(
        ({ AdminUserListComponent }) => AdminUserListComponent,
      ),
    pathMatch: 'full',
  },
  {
    path: 'new-invitation',
    loadComponent: () =>
      import('./new-invitation/new-invitation.component').then(
        ({ NewInvitationComponent }) => NewInvitationComponent,
      ),
    canDeactivate: [dirtyCheckCanDeactivateGuard()],
    title: 'PAGES.ADMIN_USER.NEW_INVITATION.BREADCRUMB',
  },
  {
    path: ':id',
    loadComponent: () =>
      import('./details/admin-user-details.component').then(
        ({ AdminUserDetailsComponent }) => AdminUserDetailsComponent,
      ),
    title: 'PAGES.ADMIN_USER.BREADCRUMB.EDIT',
    canActivate: [hasStringPathParamCanActivateGuard('id')],
    canDeactivate: [
      sequentialDeactivateGuards([
        dirtyCheckCanDeactivateGuard(),
        showToasterDeactivateGuard('PAGES.ADMIN_USER.SINGULAR'),
      ]),
    ],
  },
  {
    path: '**',
    redirectTo: '',
  },
];
